import api from "../api/api";
import {QueryAction} from "../enums/action.enum";

import {LOCATIONQUERY} from "../graphql/queries/locations.query";


export const getLocationService = async () => {
    const response = await api.call({
      requiresToken: true,
      data: {},
      query: LOCATIONQUERY,
      refine: {
        limit: 10,
      },
      action: QueryAction.GET,
    });

    if (response.data.data.findLocations) {
      return response.data.data.findLocations;
    }
};
